import React from 'react';

import noImage from '../../assets/No_image_available.png';
import { useGetBranchImage } from '../../utils/dashboard-hooks';
export const RenderImage = ({ branchId, onClick }: { branchId: number; onClick: () => Promise<void> }) => {
    const [getBranchImage] = useGetBranchImage(branchId);
    const image = getBranchImage();

    const onImageClick = () => {
        // () => setShowNewRequestModal(true)
        onClick().then();
    };

    return (
        <>
            {image ? (
                <img className='branch-img-thumb mx-2' src={image} alt='Branch' onClick={onImageClick} />
            ) : (
                <img className='branch-img-thumb mx-2' src={noImage} alt='Branch' onClick={onImageClick} />
            )}
        </>
    );
};
